import _startCase from 'lodash/startCase';
import _camelCase from 'lodash/camelCase';

const titleCase = (str) => _startCase(_camelCase(str)).replace(' ', '');

const setAuthHeader = (userToken) => ({
  headers: {
    Authorization: userToken,
  },
});

export { setAuthHeader, titleCase };
